import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppShellDesktop from './AppShell.desktop';
import AppShellMobile from './AppShell.mobile';

const AppShell = ({ header, footer, children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return <AppShellMobile footer={footer}>{children}</AppShellMobile>;
  }

  return (
    <AppShellDesktop header={header} footer={footer}>
      {children}
    </AppShellDesktop>
  );
};

export default AppShell;
